import { useCallback, useState } from "react";

import type React from "react";

interface UseConfirmationDialogProps {
  title: React.ReactNode;
  description: React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void | Promise<void>;
}

interface ConfirmationDialogReturn {
  isOpen: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  openDialog: () => void;
  dialogProps: {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    title: React.ReactNode;
    description: React.ReactNode;
    confirmText?: string;
    cancelText?: string;
    onConfirm: () => void | Promise<void>;
  };
}

export function useConfirmationDialog({
  title,
  description,
  confirmText,
  cancelText,
  onConfirm,
}: UseConfirmationDialogProps): ConfirmationDialogReturn {
  const [isOpen, setOpen] = useState(false);

  const handleConfirm = useCallback(async () => {
    await onConfirm();
  }, [onConfirm]);

  const openDialog = useCallback(() => {
    setOpen(true);
  }, []);

  return {
    isOpen,
    setOpen,
    openDialog,
    dialogProps: {
      open: isOpen,
      onOpenChange: setOpen,
      title,
      description,
      confirmText,
      cancelText,
      onConfirm: handleConfirm,
    },
  };
}
